var _rect, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuItem(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    fill: "#F1F5F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.125 34.5C50.5312 34.5 46.375 35.6875 46.375 41.0312V45.1875C46.375 46.4975 47.44 47.5625 48.75 47.5625H49.9375V52.3125C49.9375 52.9693 50.4682 53.5 51.125 53.5C51.7818 53.5 52.3125 52.9693 52.3125 52.3125V47.5625V43.4062V35.6875C52.3125 35.0307 51.7818 34.5 51.125 34.5ZM38.0625 35.0938C38.0625 34.7895 37.8361 34.5371 37.5318 34.5037C37.2275 34.4703 36.9566 34.6707 36.8898 34.9639L35.7654 40.0219C35.7135 40.2557 35.6875 40.4932 35.6875 40.7307C35.6875 42.434 36.99 43.833 38.6562 43.9852V52.3125C38.6562 52.9693 39.1869 53.5 39.8438 53.5C40.5006 53.5 41.0312 52.9693 41.0312 52.3125V43.9852C42.6975 43.833 44 42.434 44 40.7307C44 40.4932 43.974 40.2557 43.9221 40.0219L42.7977 34.9639C42.7309 34.667 42.4525 34.4703 42.152 34.5037C41.8514 34.5371 41.625 34.7895 41.625 35.0938V40.0738C41.625 40.2742 41.4617 40.4375 41.2613 40.4375C41.0721 40.4375 40.9162 40.2928 40.8977 40.1035L40.4338 35.0418C40.4078 34.7338 40.1518 34.5 39.8438 34.5C39.5357 34.5 39.2797 34.7338 39.2537 35.0418L38.7936 40.1035C38.775 40.2928 38.6191 40.4375 38.4299 40.4375C38.2295 40.4375 38.0662 40.2742 38.0662 40.0738V35.0938H38.0625ZM39.8549 40.7344H39.8438H39.8326L39.8438 40.7084L39.8549 40.7344Z",
    fill: "#526077"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuItem);
export default __webpack_public_path__ + "static/media/menu-item.f0feed31ca34c46a55766fb624627834.svg";
export { ForwardRef as ReactComponent };